if (!customElements.get('cribton-day-picker')) {
  customElements.define('cribton-day-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const filters = this.querySelector('[role="group"]');
      const groups = [...this.querySelectorAll('[data-session-day]')];
      const status = this.querySelector('[data-status]');
      const empty = this.querySelector('[data-empty]');
      filters.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-day]');
        if (!button || !filters.contains(button)) return;
        const selected = button.dataset.day;
        let count = 0;
        groups.forEach(group => {
          group.hidden = selected !== 'all' && group.dataset.sessionDay !== selected;
          if (!group.hidden) count += group.querySelectorAll('li').length;
        });
        filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        empty.hidden = count > 0 || groups.some(group => !group.hidden && group.hasAttribute('data-closure'));
        status.textContent = status.dataset.countLabel.replace('__COUNT__', count).replace('__DAY__', button.getAttribute('aria-label') || button.textContent.trim());
      });
      const openVenue = (hash, focus = true) => {
        let target;
        try { target = this.ownerDocument.getElementById(decodeURIComponent(hash.slice(1))); } catch { return false; }
        if (!target || !this.contains(target)) return false;
        const venue = target.closest('details.cribton-timetable__venue');
        if (!venue) return false;
        venue.open = true;
        if (focus) venue.querySelector('summary').focus({ preventScroll: true });
        venue.scrollIntoView({ block: 'start', behavior: 'instant' });
        return true;
      };
      this.addEventListener('click', event => {
        const link = event.target.closest('a[data-venue-link]');
        if (!link || !this.contains(link) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (!openVenue(link.hash)) return;
        event.preventDefault();
        if (window.location.hash !== link.hash) window.history.pushState(null, '', link.hash);
      });
      filters.hidden = false;
      if (window.location.hash) openVenue(window.location.hash, false);
    }
  });
}
